import { CardCheckbox } from '@/components/ui/CardCheckbox'
import { TRAVEL_RANGE_OPTIONS } from './packetData'

/**
 * Multi-select travel range, the same question and values the application asks
 * ("How far do you typically travel from your home base?") minus the emoji
 * prefix the chat renderer adds.
 */
export function TravelRangeField({
  selected,
  onChange,
  disabled,
}: {
  selected: string[]
  onChange: (values: string[]) => void
  disabled?: boolean
}) {
  function toggle(value: string, checked: boolean) {
    onChange(checked ? [...selected, value] : selected.filter((v) => v !== value))
  }

  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {TRAVEL_RANGE_OPTIONS.map((option) => (
        <CardCheckbox
          key={option.value}
          isChecked={selected.includes(option.value)}
          onChange={(checked) => toggle(option.value, checked)}
          size="sm"
          onDark
          disabled={disabled}
        >
          {option.name} <span className="text-ink-300 font-normal">({option.range})</span>
        </CardCheckbox>
      ))}
    </div>
  )
}
